import React from "react";

export const Context = React.createContext({
  loading: false,
  tableData:null,
  
});